/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.tickets.create.controllers', [
  'ui.bootstrap',
  'ui.router',
  'acme.common.service.helpers',
  'acme.common.service.api',
  'acme.common.factory.notice',
  'acme.common.service.validate',
  'acme.common.service.calendar',
  'acme.common.service.ticketConfig',
  'acme.common.service.userPreferences'
])

.controller('LayoutsTicketsCreateController', ['$scope', '$state', '$uibModal', '$location', '$timeout', '$filter', 'HelpersService', 'ApiService', 'NoticeFactory', 'ValidateService', 'CalendarService', 'TicketConfigService', 'UserPreferencesService', function($scope, $state, $uibModal, $location, $timeout, $filter, HelpersService, ApiService, NoticeFactory, ValidateService, CalendarService, TicketConfigService, UserPreferencesService) {

    $scope.layoutsTicketsCreate = {

      model: {},
      mode: 'create',

      publishDate: false,
      draftDate: false,

      validators: [],

      cap: HelpersService.cap,

      notice: new NoticeFactory(),

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      isPublish: false,
      isSaving: false,

      init: function() {
        if ($state.params.id) {
          this.mode = 'edit';
        }

        $scope.$emit('Application::contentTitleChange', {
          title: HelpersService.cap(this.mode) + ' Ticket Layout',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $scope.layoutsTicketsCreate.cancel();
            }
          },
          buttonRight: {
            label: (this.isMode('edit')) ? 'Save and Close' : 'Create',
            permissions: (this.isMode('edit')) ? 'TICKET_LAYOUTS_UPDATE' : 'TICKET_LAYOUTS_CREATE',
            action: function() {
              $scope.layoutsTicketsCreate.complete(false, {name: 'application.layouts.tickets.list'});
            }
          }
        });

        if (this.isMode('edit')) {
          this.getTicketConfig();
        }else {
          TicketConfigService.resetModel();
        }

        this.initValidators();
      },

      isMode: function(mode) {
        return this.mode === mode;
      },

      getState: function (name) {
        var stateName = 'application.layouts.tickets',
          stateParams = {};

        if (this.mode === 'create') {
          stateName += '.create.'+name;
        }else{
          stateName += '.edit.'+name;
          stateParams.id = $state.params.id;
        }

        this.complete(false, {
          name: stateName,
          stateParams: stateParams
        });
      },

      isState: function (path) {

        var location = $location.path();

        return (location.indexOf(path) !== -1);

      },

      initValidators: function() {
        this.validators = [
          {
            field: 'layouts-tickets-create-header-name',
            len: {
              message: 'The configuration name must not be empty',
              test: function() {
                var self = $scope.layoutsTicketsCreate;
                return {
                  value: self.model.name
                };
              }
            }
          }
        ];
      },

      getTicketConfig: function() {
        ApiService.tickets.detail($state.params.id).then(this.success.getTicketConfig, this.error.getTicketConfig);
      },

      getError: function(field) {
        return ValidateService.getError(field);
      },

      setUpdateTimes: function(ticketConfig) {
        if (ticketConfig && ticketConfig.status) {
          if (ticketConfig.status.draftDate) {
            this.draftDate = $filter('date')(CalendarService.parseDate(ticketConfig.status.draftDate), this.dateTimeFormat);
          }
          if (ticketConfig.status.publishDate) {
            this.publishDate = $filter('date')(CalendarService.parseDate(ticketConfig.status.publishDate), this.dateTimeFormat);
          }
        }
      },

      cancel: function() {
        $state.go('application.layouts.tickets.list');
      },

      complete: function(publish, state) {
        this.isPublish = publish || false;
        this.isSaving = true;
        if (this.isMode('edit')) {
          this.update(state);
        }else{
          this.create(state);
        }
      },

      publish: function() {
        this.complete(true);
      },

      remove: function() {
        var self = $scope.layoutsTicketsCreate;

        self.modalDialog = $uibModal.open( {
          templateUrl: 'views/application/views/layouts/tickets/modals/layoutsTicketsRemoveModal.tpl.html',
          size: 'md',
          controller: 'LayoutsTicketsRemoveModalController',
          resolve: {
            item : self.model,
            events: function() {
              return {
                data: {
                  payload: []
                }
              };
            },
            allow: !self.model.assigned
          }
        });

        self.modalDialog.result.then( function() {
          ApiService.tickets.remove(self.model.id).then(function(response) {
            self.cancel();
          });
        }, function() {
          // do nothing});
        });
      },

      showPublishModal: function() {
        var self = $scope.layoutsTicketsCreate;

        if (self.isPublish) {
          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
            size: 'md',
            controller: 'ReportsCreateShowMessageModalController',
            resolve: {
              currentTitle: function () {
                return 'Ticket Layout Published';
              },
              currentMessage: function () {
                return 'The ticket layout "' + self.model.name + '" has been published. It may take up to a minute for the published changes to take effect.';
              },
              safe: function() {
                return false;
              }
            }
          });
          // Invoked when modal completes with close(params)
          self.showModal.result.then(function () {
          }, function () {
            // Do nothing
          });
        }
      },

      update: function(state) {
        var self = $scope.layoutsTicketsCreate,
            processed;

        self.notice.hideMessages();

        $scope.$broadcast('LayoutsTickets::Save');

        $timeout(function() {
          if (ValidateService.validate(self.validators) ) {
            processed = TicketConfigService.getModel();
            processed.name = self.model.name;

            ApiService.tickets.update(processed, self.isPublish).then( function(response) {
              self.success.update(response);
              if (state) {
                $state.go(state.name);
              }
            }, self.error.update);
          }
        }, 0);
      },

      create: function(state) {
        var self = $scope.layoutsTicketsCreate,
            processed;

        $scope.$broadcast('LayoutsTickets::Save');

        $timeout(function() {
          if (ValidateService.validate(self.validators) ) {
            processed = TicketConfigService.getModel();
            processed.name = self.model.name;

            ApiService.tickets.create(processed).then(function(response) {
              self.success.create(response);
              if (state) {
                $state.go(state.name);
              }
            }, self.error.create);
          }
        }, 0);
      },

      success: {
        init: function(response) {},
        getTicketConfig: function(response) {
          var self = $scope.layoutsTicketsCreate;

          self.model = response.data.payload;
          TicketConfigService.setModel(response.data.payload);

          self.setUpdateTimes(response.data.payload);
          $scope.$broadcast('LayoutsTickets::Update');
        },
        create: function(response) {
          var self = $scope.layoutsTicketsCreate;
          self.model.id = response.data.payload.id;
          self.isSaving = false;
          if (!self.isMode('edit')) {
            $state.go('application.layouts.tickets.edit.definition', {id: self.model.id});
          }
        },
        update: function(response) {
          var self = $scope.layoutsTicketsCreate;
          if (self.isPublish) {
            self.showPublishModal();
            self.isPublish = false;
          }
          self.isSaving = false;
          self.setUpdateTimes(response.data.payload);
        }
      },

      error: {
        init: function(response) {},
        getTicketConfig: function(response) {},
        create: function(response) {
          var self = $scope.layoutsTicketsCreate;
          self.isSaving = false;
          self.isPublish = false;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        update: function(response) {
          var self = $scope.layoutsTicketsCreate;
          self.isSaving = false;
          self.isPublish = false;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      }

    };

    $scope.layoutsTicketsCreate.init();

}]);